import { WSAlert, WSInfoBox, WSText } from "@wingspanhq/fe-component-library";
import React from "react";
import { IFormNote } from "../types";
import { noteIcon, noteTheme } from "./advisoryStyle";
import { linkifyText } from "../utils/linkifyNotes";

type Props = {
  note: IFormNote;
  size?: "S";
};

// Renders a single form note. Info-level notes render as a subtle, non-boxed
// field-level note (matching the Figma "Note:" helper text); warnings keep the
// amber boxed alert treatment; `variant: "box"` notes render as a WSInfoBox
// with an optional title and trailing link. Neither is dismissible — the
// collected advisory copy must stay visible for the contractor. URLs in the
// message are linkified.
export const DynamicFormNote: React.FC<Props> = ({ note, size }) => {
  if (note.variant === "box") {
    return (
      <WSInfoBox
        title={note.title}
        size={size ?? "M"}
        // Info-level boxes keep the neutral gray treatment from the design;
        // warning-level ones use the amber theme.
        theme={note.level === "warning" ? "warning" : undefined}
      >
        <WSText.ParagraphSm color="gray600">
          {linkifyText(note.message)}
          {note.linkText && note.linkUrl ? (
            <>
              {" "}
              <a href={note.linkUrl} target="_blank" rel="noopener noreferrer">
                <WSText.ParagraphSm inline color="blue500">
                  {note.linkText}
                </WSText.ParagraphSm>
              </a>
            </>
          ) : null}
        </WSText.ParagraphSm>
      </WSInfoBox>
    );
  }

  if (note.level === "info") {
    return (
      <WSText.ParagraphSm color="gray500">
        {linkifyText(note.message)}
      </WSText.ParagraphSm>
    );
  }

  return (
    <WSAlert
      size={size}
      theme={noteTheme(note.level)}
      icon={noteIcon(note.level)}
    >
      {linkifyText(note.message)}
    </WSAlert>
  );
};
